import { Skeleton } from "@mui/material";

function CustomRectangularSkeleton({ sx = [], ...props }) {
  return (
    <Skeleton
      variant="rectangular"
      height={60}
      width={"100%"}
      sx={[{ borderRadius: 2 }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...props}
    />
  );
}

export default CustomRectangularSkeleton;
